const colors = {
  blue400: "#60a5fa",
  cloudyblue: "#aaaad2",
  /** @deprecated use blue400 instead. */
  drop: "#5dadec",
  fireHighlight: "#ffcc4d",
  /** @deprecated use orange400 instead. */
  fireOrange: "#f4900c",
  orange400: "#fb923c",
  red400: "#F87171",
  slateus100: "#dee2f1",
  slateus200: "#b5bddb",
  slateus400: "#8991ad",
  slateus450: "#8888af",
  slateus500: "#464b6f",
  slateus600: "#2d344a",
  slateus700: "#1b2236",
  slateus800: "#131827",
  white: "#ffffff",
};

export default colors;
